import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  p {
    margin-bottom: 1rem;
  }
  
  ul {
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  svg {
    display: initial;
  }

  .popover {
    font-family: inherit;
  }

  a {
    color: #007bff;
    text-decoration: none;
  }

  .form-label.required:after {
    color: #f03e3e;
    content: "*";
    margin-left: 0.1rem;
  }

  input.form-control {
    color: #404040;
    ::placeholder {
      color: #A5A1A2;
    }
  }

  .flex-basis-auto {
    flex-basis: auto !important;
  }

  .lb-popover {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: 0.015625rem;
    box-shadow: 0.0625rem 0.0625rem 0.25rem rgba(0, 0, 0, 0.1);
    border-radius: 0.1875rem;
    .popover-body {
      color: #404040;
    }
  }

  .z-index-0 {
    z-index: 0;
  }

  .min-width-max-content {
    min-width: max-content;
  }

  .font-size-inherit {
    font-size: inherit;
  }

  .line-height-inherit {
    line-height: inherit;
  }

  .sui-c-link-secondary {
    color: #2c2e30;
  }
`;

export default GlobalStyle;
